import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMacintosh: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="macintosh, mac"><path d="M13.75 15.25H16.25M5.75 18.5V21.25H18.25V18.5M4.75 2.75H19.25V18.25H4.75V2.75ZM7.75 5.75H16.25V12.25H7.75V5.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMacintosh;
